var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#000"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M13.743 3L14.667 3.924 5.714 12.876 1.333 8.496 2.257 7.572 5.714 11.029z","transform":"translate(-984 -3755) translate(980 3708) translate(0 40) translate(4 7)"})))))));
}

Check.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Check;

Check.default = Check;
